import type { PermissionId } from "@/lib/permissions/catalog";
import type { UserRole } from "@/lib/permissions/roles";

/** Client-safe helpers — no server/db imports. */
export function hasProductFeatureBypassClient(
	role: UserRole | undefined,
	permissions: PermissionId[] | readonly ["*"] | undefined,
): boolean {
	if (!role) return false;
	if (role === "admin") return true;
	if (!permissions) return false;
	if (permissions.length === 1 && permissions[0] === "*") return true;
	return (permissions as readonly PermissionId[]).includes("product.features.bypass");
}

export function isStaffAccount(role: UserRole | string | null | undefined): boolean {
	return role === "admin" || role === "support";
}
